<template>
  <div>
    <div class="pb-2 mb-2">
      <v-chip-group column>
        <v-chip
          v-for="(word, i) in wordArray"
          :key="i"
          close
          color="green-1"
          close-icon="mdi-close"
          @click:close="removeWord(word)"
        >
          <v-avatar left class="mr-0"> # </v-avatar>
          {{ word }}
        </v-chip>
      </v-chip-group>
    </div>
    <v-text-field
      hide-details
      outlined
      label="Nytt nyckelord"
      placeholder="Nyckelord"
      v-model="newKeyword"
      @keyup.enter="addWord"
    ></v-text-field>
  </div>
</template>

<script>
import { stopwords } from '../../assets/data/stopwords-sv'

export default {
  name: 'Keywords',
  props: {
    value: { type: String, default: '' },
  },
  data() {
    return {
      newKeyword: '',
    }
  },
  computed: {
    wordArray() {
      if (!this.value) return []
      if (!this.value.trim()) return []
      const words = this.value.split(' ').map((w) => w.toLowerCase().trim())
      return [...new Set(words.filter((w) => !stopwords.includes(w)))]
    },
  },
  methods: {
    addWord() {
      if (!this.newKeyword) return
      const words = [...this.wordArray, this.newKeyword]
      this.$emit('input', words.join(' '))
      this.newKeyword = ''
    },
    removeWord(word) {
      this.$emit('input', this.wordArray.filter((w) => w !== word).join(' '))
    },
  },
}
</script>

<style lang="less" scoped></style>
